import { Button} from 'antd';
import React, { useState } from 'react'
import titul from '../Components/fayl/titul.jpg'


const Titul = () => {
    const [setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    return (
        <div className="card" >
            <Button className='button' onClick={showModal}>
                 <a href={titul}>Titul</a>
            </Button>

        </div>
    )
}


export default Titul